// src/components/Customer.jsx
import React, { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Card,
  Button,
  Container,
  Table,
  Modal,
  Spinner,
  Alert,
} from "react-bootstrap";
// import { PDFViewer } from "@react-pdf/renderer";
import InvoiceForm from "./InvoiceForm";
import ReuseRecurringInvoiceButton from "./ReuseRecurringInvoiceButton";
import { UserContext } from "../context/UserContext";
import axios from "axios";

const Customer = () => {
  const { id } = useParams();
  const [customer, setCustomer] = useState(null);
  const [invoices, setInvoices] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [modalInfo, setModalInfo] = useState({ title: "", body: "" });
  const [errMsg, setErrMsg] = useState("");
  const [confirmShow, setConfirmShow] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [showDeleted, setShowDeleted] = useState(false);

  const { user } = useContext(UserContext);

  useEffect(() => {
    const fetchCustomerDetails = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/customers/customer/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setCustomer(response.data);
      } catch (error) {
        console.error("Error fetching customer details:", error);
      }
    };

    fetchCustomerDetails();
  }, [id]);

  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          // `${process.env.REACT_APP_API_URL}/invoices/${id}`,
          `${process.env.REACT_APP_API_URL}/invoices/${id}?deleted=${showDeleted}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setInvoices(response.data);
      } catch (error) {
        console.error("Error fetching customer details:", error);
      }
    };

    fetchInvoices();
  }, [refresh, id, showDeleted]);

  // 🔴 DELETE CONFIRMED
  const confirmDeleteInvoice = async () => {
    try {
      setDeleteLoading(true);
      const token = localStorage.getItem("token");

      await axios.delete(
        `${process.env.REACT_APP_API_URL}/invoices/delete/${selectedInvoice.id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      setConfirmShow(false);
      setSelectedInvoice(null);
      setRefresh((prev) => !prev);
    } catch (error) {
      console.error("Error deleting invoice:", error);
      setErrMsg("Failed to delete invoice.");
    } finally {
      setDeleteLoading(false);
    }
  };
  //Restore deleted invoice
  const restoreInvoice = async (invoiceId) => {
    try {
      const token = localStorage.getItem("token");

      await axios.put(
        `${process.env.REACT_APP_API_URL}/invoices/restore/${invoiceId}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      setRefresh((prev) => !prev);
    } catch (error) {
      console.error("Restore failed:", error);
      setErrMsg("Failed to restore invoice.");
    }
  };

  if (!customer) {
    return (
      <Container
        style={{ height: "100vh", fontSize: "250px" }}
        className="d-flex justify-content-center align-items-center"
      >
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {props.modalInfo.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{props.modalInfo.body}</Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>Cancel</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  return (
    <Container className="mt-5" style={{ width: "100vw" }}>
      <Card style={{ width: "100%" }}>
        <Card.Body>
          <Card.Title>
            <h1>{customer.name}</h1>
          </Card.Title>
          <Card.Subtitle className="mb-2 text-muted">
            {customer.email}
          </Card.Subtitle>

          <Card.Text>
            <strong>Address:</strong> {customer.address}
          </Card.Text>
          <h2>Invoices List</h2>
          <div>
            {errMsg && (
              <div className="error-message">
                <Alert variant="danger">{errMsg}</Alert>
              </div>
            )}
          </div>
          <Button
            variant="outline-secondary"
            className="mb-3"
            onClick={() => setShowDeleted(!showDeleted)}
          >
            {showDeleted ? "Hide Deleted" : "Show Deleted"}
          </Button>

          <Table striped bordered hover className="overflow-auto">
            <thead>
              <tr>
                <th>Number</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {invoices &&
                invoices.map((invoice) => (
                  <tr key={invoice.id}>
                    <td>{invoice.invoiceNumber}</td>
                    <td>
                      {new Date(invoice.date).toLocaleDateString("en-AU")}
                    </td>
                    {/* <td>
                      <Button
                        onClick={() => {
                          setModalShow(true);
                          setModalInfo({
                            title: `${invoice.invoiceNumber}`,
                            body: (
                              <InvoicePrinter
                                invoice={invoice}
                                customer={customer}
                                user={user}
                              />
                            ),
                          });
                        }}
                      >
                        Open Invoice
                      </Button>
                    </td> */}
                    <td className="d-flex gap-2">
                      <Link to={`/invoice/${invoice.id}`}>
                        <button className="btn btn-primary">
                          open invoice
                        </button>
                      </Link>
                      <ReuseRecurringInvoiceButton
                        invoice={invoice}
                        onError={setErrMsg}
                        onReused={() => setRefresh((prev) => !prev)}
                      />
                      {invoice.deletedAt ? (
                        <Button
                          variant="success"
                          size="sm"
                          onClick={() => restoreInvoice(invoice.id)}
                        >
                          Restore
                        </Button>
                      ) : (
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => {
                            setSelectedInvoice(invoice);
                            setConfirmShow(true);
                          }}
                        >
                          Delete
                        </Button>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
          <Button
            onClick={() => {
              setModalShow(true);
              setModalInfo({
                title: "Create a new invoice",
                body: (
                  <InvoiceForm
                    CustomerId={customer.id}
                    customerName={customer.name}
                    setModalShow={setModalShow}
                    setRefresh={setRefresh}
                    setErrMsg={setErrMsg}
                  />
                ),
              });
            }}
          >
            Create Invoice
          </Button>
        </Card.Body>
      </Card>
      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        modalInfo={modalInfo}
      />
      {/* 🔥 PROFESSIONAL CONFIRM DELETE MODAL */}
      <Modal show={confirmShow} onHide={() => setConfirmShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title className="text-danger">
            Confirm Invoice Deletion
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {selectedInvoice && (
            <>
              <p>Are you sure you want to delete invoice:</p>
              <h5 className="text-center text-danger">
                #{selectedInvoice.invoiceNumber}
              </h5>
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setConfirmShow(false)}
            disabled={deleteLoading}
          >
            Cancel
          </Button>

          <Button
            variant="danger"
            onClick={confirmDeleteInvoice}
            disabled={deleteLoading}
          >
            {deleteLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  className="me-2"
                />
                Deleting...
              </>
            ) : (
              "Delete Invoice"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default Customer;
